<template>
    <mobile v-if="gl.isMobile" class="mt-4" />
    <desktop v-else />
</template>

<script>
import { useGl } from '@store/ts/gl';

// components
import Desktop from '@pages/tools/desktop.vue';
import Mobile from '@pages/tools/mobile.vue';

export default {
    name: 'AccountInfo',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        const gl = useGl();
      
        return {
            gl,
        };
    },
};
</script>